export const WORKFLOW_ID = 'EducationWorkflow';
export const ANALYTICS_ID = 'education_workflow';
